import ReactController from '~/controllers/react_controller'
import AWSEKSDashboardCharts from '~/dashboard/aws_eks_dashboard_charts'

export default class AWSEKSDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
    namespaces: Array,
    deployments: Array,
    clusters: Array,
    nodes: Array,
    workloadTypes: Array,
    workloadNames: Array,
  }

  createComponent() {
    return (
      <AWSEKSDashboardCharts
        namespaces={this.namespacesValue}
        deployments={this.deploymentsValue}
        clusters={this.clustersValue}
        nodes={this.nodesValue}
        workloadTypes={this.workloadTypesValue}
        workloadNames={this.workloadNamesValue}
        organizationId={this.organizationIdValue}
      />
    )
  }
}
